module.exports = __webpack_public_path__ + "media/orderLose.7aca6797.mp3";